<template>
<div class="jumbotron jumbotron-fluid gradient my-5">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="d-flex flex-row justify-content-between align-items-center mt-3">
                    <div></div>
                    <div>
                        <h1 v-html="title"></h1>
                    </div>
                    <div href="#" v-scroll-to="'#home'">
                        <i class="fa fa-lg fa-angle-double-up"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ['title']
}
</script>

<style scoped>
.gradient {
    background: linear-gradient(to right, rgba(0, 83, 149, 0.05), rgba(83, 135, 177, 0));
}
</style>
